export default {
  common: {
    welcome: '欢迎访问我们的网站',
    switchLanguage: '切换语言'
  },
  nav: {
    home: '首页',
    about: '关于我们',
    contact: '联系我们'
  }
};



// WEBPACK FOOTER //
// ./src/lang/zh.js